// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, Fragment, useState, useRef, useEffect} from 'react';
import styles from '../../pages/toolip.io/dashboard.module.less';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import Svg_gift_free_plan from '../../img/dashboard/gift_free_plan.svg';
import {Button} from '../../../../hola/pub/lib/button';
import {App_context} from 'hola_app_context';
import {i_promo_state, Welcome_promo_dialog} from './welcome_promo_dialog';
// @ts-ignore
import {get, set} from '/util/storage.js';
import {use_qs_with_set} from '../../../../hola/pub/lib/use_qs';
import {use_debug_ui} from '../../../../hola/pub/lib/debug';
import {Products_cards} from '../free_proxy/product_cards';
import {www_hola} from 'hola_opt';

type t_open_promo_cb = (state?: i_promo_state)=>void;

export const Welcome_promo = ()=>{
    const {user} = useContext(App_context);
    const {qs, set_qs} = use_qs_with_set();
    const is_promo_closed = get('promo_dialog_closed');
    const promo_state = useRef(undefined);
    const [is_promo_open, set_is_promo_open] =
        useState(!is_promo_closed && !qs.thank_you);
    const open_promo: t_open_promo_cb = state=>{
        promo_state.current = state;
        set_is_promo_open(true);
    };
    const pricing_plans_debug = use_debug_ui('pricing_plans');
    const show_pricing_cards_promo = is_promo_closed && (pricing_plans_debug
        || www_hola.dashboard_pricing_plans);
    useEffect(()=>{
        if (qs.selected_type)
        {
            promo_state.current = {
                selected_slide_idx: 2,
                selected_proxy_type: qs.selected_type
            };
            set_is_promo_open(true);
            set_qs({selected_type: undefined});
        }
    }, [qs.selected_type]);
    return <Fragment>
      <Welcome_promo_dialog
        user={user} is_promo_open={is_promo_open}
        init_state={promo_state.current}
        close_dialog={()=>{
          set_is_promo_open(false);
          promo_state.current = undefined;
          set('promo_dialog_closed', true);
        }}/>
      {!is_promo_open && (show_pricing_cards_promo
        ? <Pricing_cards_promo open_promo_dialog={open_promo}/>
        : <Welcome_promo_block open_promo_dialog={open_promo}/>
      )}
    </Fragment>;
};

const Welcome_promo_block = (props: {open_promo_dialog: t_open_promo_cb})=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.welcome_pro}>
        <Svg_gift_free_plan />
        <p className={cn(theme.p18, theme.med)}>
          Get a free plan tailored to your needs</p>
        <p className={cn(theme.p16, theme.med, theme.color_n400)}>
          Get started right away and enjoy your proxy plan on the house</p>
        <Button caption="Get started" color={'black'} target="_blank"
          as_external on_click={()=>props.open_promo_dialog()} size={'sm'}
          round={false}/>
    </div>;
};

const Pricing_cards_promo = (props: {open_promo_dialog: t_open_promo_cb})=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.product_cards_promo}>
      <div className={styles.get_started_banner}>
        <p className={cn(theme.p22, theme.med)}>
          Get a free plan tailored to your needs</p>
        <p className={cn(theme.p16, theme.color_n500)}>
          Get started right away and enjoy your proxy plan on the house</p>
        <Button caption="Get started" color={'black'} target="_blank"
          as_external on_click={()=>props.open_promo_dialog()} size={'sm'}
          round={false} cls={styles.cta}/>
      </div>
      <Products_cards shown={true} bg={<></>} cls={styles.promo_cards}
        get_cta={type=>{
          return {
            to: undefined,
            size: 'sm',
            on_click: ()=>props.open_promo_dialog({
              selected_slide_idx: 2,
              selected_proxy_type: type,
            }),
          };
        }}
      />
    </div>;
};
